import { render } from "./ByosChooseCategory.vue?vue&type=template&id=48390fe4"
import script from "./ByosChooseCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosChooseCategory.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosChooseCategory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48390fe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48390fe4', __exports__)) {
    api.reload('48390fe4', __exports__)
  }
  
  module.hot.accept("./ByosChooseCategory.vue?vue&type=template&id=48390fe4", () => {
    api.rerender('48390fe4', render)
  })

}


export default __exports__